/* eslint-disable react/jsx-no-constructed-context-values */
import { Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Homepage from "./home";
import Dashboard from "./dashboard/Dashboard";
import OrderRedrive from "./redrive/OrderRedrive";
import PaymentRedrive from "./redrive/PaymentRedrive";
import DlqRedrive from "./dlq/DlqRedrive";
import { UatPortal } from "./uat/UatPortal";
import { AnalyticsProvider } from "./dashboard/AnalyticsProvider";

export default function App() {
  const queryClient = new QueryClient();

  document.body.classList.add("awsui-visual-refresh");

  return (
    <AnalyticsProvider>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/find" element={<Homepage />} />
          <Route path="/saved" element={<Homepage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/uat" element={<UatPortal />} />
          <Route path="/redrive" element={<OrderRedrive />} />
          <Route path="/payment-redrive" element={<PaymentRedrive />} />
          <Route path="/dlq-redrive" element={<DlqRedrive />} />
        </Routes>
      </QueryClientProvider>
    </AnalyticsProvider>
  );
}
